import { render, staticRenderFns } from "./copycollectormodel.vue?vue&type=template&id=a3399806&"
import script from "./copycollectormodel.vue?vue&type=script&lang=ts&"
export * from "./copycollectormodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copycollectormodel.vue"
export default component.exports